import axios from 'axios';
import Cookie from 'js-cookie';
import { MessageBox,Message  } from 'element-ui'
import { auth } from '@/api';
import store from '@/store';
import router from '@/router';
import { debounce } from '@/utils';

// const axios = axios.create();

// axios.defaults.withCredentials = true;

// 要求更新完token再请求，请使用此延迟函数
/* eslint-disable no-param-reassign */
// function debounce(method, delay) {
//   clearTimeout(method.tId);
//   method.resolveTasks = method.resolveTasks || [];
//   method.rejectTasks = method.rejectTasks || [];
//   return new Promise((resolve, reject) => {
//     method.resolveTasks.push(resolve);
//     method.rejectTasks.push(reject);
//     method.tId = setTimeout(() => method().then(() => {
//       method.resolveTasks.forEach(item => item());
//       method.resolveTasks = [];
//       method.rejectTasks = [];
//     }, (err) => {
//       method.rejectTasks.forEach(item => item(err));
//       method.resolveTasks = [];
//       method.rejectTasks = [];
//     }), delay);
//   });
// }

function tokenErr() {
  //MessageBox.close();
  Cookie.remove('token', { domain: '.izhikang.com' });
  Cookie.remove('tokenExpireTime', { domain: '.izhikang.com' });
  Cookie.remove('userName', { domain: '.izhikang.com' });
  Cookie.remove('userId', { domain: '.izhikang.com' });
  Message.closeAll();
  // Message.error({
  //   content: '登录信息已过期或无效，请重新登录',
  //   duration: 10,
  //   closable: true,
  // });
  router.push({
    name: 'login',
    query: { target: encodeURIComponent(window.location.href) },
  });
}

function refreshToken() {
  store.commit('global/TOGGLE_LOADING', 'start');
  const refresh = axios.create();
  refresh.defaults.headers.common.token = Cookie.get('token');
  refresh({
    method: 'post',
    url: auth.refreshToken,
    withCredentials: true,
  }).then((response) => {
    if (response.data.ret === true) {
      store.commit('auth/REFRESH_TOKEN');
      store.commit('global/TOGGLE_LOADING', 'finish');
    } else {
      store.commit('global/TOGGLE_LOADING', 'error');
      // 若token解析失败，已过期 则返回登录页，清除已过期token
      if (response.data.errcode === -11001) {
        tokenErr();

      } else {
        Message.closeAll();
        Message({
          message: response.data.msg,
          type: 'error',
          duration: 6000,
          customClass:'messageZIndex',
        });
      }
    }
  }).catch(() => {
    store.commit('global/TOGGLE_LOADING', 'error');
    Message.closeAll();
    Message({
      message: '服务器开小差了',
      duration: 6000,
      type: 'error',
      customClass:'messageZIndex',
    });
  });
}

const methods = ['get', 'post', 'delete', 'put'];

class Client {
  constructor() {
    methods.forEach((method) => {
      this[method] = (url, { params = {}, data = {},headers } = {}, frontCode,globalLoading=true,returnErr=false,needReturnRes=false) => {
        if (router.currentRoute.name !== 'login') {
          const token = Cookie.get('token');
          const tokenExpireTime = Cookie.get('tokenExpireTime');
          if (token && tokenExpireTime) {
            const now = new Date().getTime();
            if (now > tokenExpireTime - (10 * 60 * 1000) && now < tokenExpireTime) {
              debounce(refreshToken, 500);
            } else if (now > tokenExpireTime) {
              tokenErr();
              return Promise.reject();
            }
          }
        }
        return new Promise((resolve, reject) => {
          if(globalLoading){
            store.commit('global/TOGGLE_LOADING', 'start')
          }
          const request = axios.create({
            baseURL: process.env.BASE_API, // url = base url + request url
            withCredentials: true,
            timeout: 50000 // request timeout
          });
          const token = Cookie.get('token');
          if (!frontCode) {
            const notFrontCode = ['login', 'guide', 'not-found'].indexOf(router.currentRoute.name) > -1;
            frontCode = notFrontCode ? '' : router.currentRoute.name; // eslint-disable-line no-param-reassign
          }
          if (frontCode && frontCode !== 'NOT') {
            request.defaults.headers.common.frontCode = frontCode;
          }
          if (token) {request.defaults.headers.common.token = token;}
          request.defaults.headers.common.sysCode = 'izk-authservice';
          // request.defaults.headers.common.timestamp = new Date().valueOf();
          request({
            headers: {
              timestamp: Date.now().valueOf(),
              cityCode: window.localStorage.getItem('cityCode') ? window.localStorage.getItem('cityCode'):'010',
              ...headers
            },
            method,
            url,
            params: method === 'get' ? {
              ...params,
              _: new Date().getTime(),
            } : '',
            data:data,
          }).then((response) => {
            if (response.data.ret === true) {
              if (response.data.data && response.data.data.needMsg) {
                Message({
                  message: response.data.msg,
                  duration: 6000,
                  type: 'warning',
                  customClass:'messageZIndex',
                });
              }
              store.commit('global/TOGGLE_LOADING', 'finish');
              if (needReturnRes) {
                return resolve(response.data);
              }
              return resolve(response.data.data);
            }
            store.commit('global/TOGGLE_LOADING', 'error');

            // 若token解析失败，已过期 则返回登录页，清除已过期token
            if (response.data.errcode === -11001) {
              tokenErr();
              return;
            } else if (response.data.errcode === 400408) {
              MessageBox({
                title: '提示',
                message: response.data.msg,
                confirmButtonText: '修改密码',
                type: 'error'
              }).then(() => {
                router.push({
                  path: '/changepwd',
                  query: {
                    tel: response.data.data,
                  },
                });
              }).catch(() => {

              })
            } else {
               Message({
                 message: response.data.msg,
                 type: 'error',
                 duration: 6000,
                 customClass:'messageZIndex',
               });
               if(returnErr){
                return reject(response.data);
               }else{
                return;
               }

            }
            return resolve(response.data);
          }).catch((err) => {
            store.commit('global/TOGGLE_LOADING', 'error');
             Message.closeAll();
             Message({
               message: '服务器开小差了',
               duration: 6000,
               type: 'error',
               customClass:'messageZIndex',
             });
            //return reject(err);

          });
        });
      };
    });
  }
}
export default new Client();



// WEBPACK FOOTER //
// ./src/utils/client.js